var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refundHeader"},[_c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("@/assets/images/home/logo1.png"),"alt":""}}),_c('h2',[_vm._v("退款申请")])])])
}]

export { render, staticRenderFns }